// Build-time constants for this dashboard.
//
// Replaces the old root `config.js`, which was imported via a bare, absolute,
// root-relative specifier ('/config') — a Vite-only trick that resolves against
// the project root — and also carried empty credential fields and a dev-machine
// export path (both dropped, IA_ABSORPTION_PLAN Phase 2 step 7).
//
// The two host values reach createDashboard as dashboard.config.js's `transport`
// (IA_ABSORPTION_PLAN Phase 3 step 8). `API_URL` is a *default only*: the host
// passes `apiUrl` as a URL param and the dashboard's start() overwrites
// `settings.apiUrl` at boot. Hosts here are bare (no scheme, no path) — see
// @rdrive/data-transport (src/proxyFetcher.js).

/** rdrive integration proxy host. */
export const PROXY_URL = 'integration-proxy.rdrive.io';

/** Default rdrive API host, overridden by the `apiUrl` URL param at boot. */
export const API_URL = 'uk-v6.rdrive.io';

/**
 * GA4 measurement id — dashboard.config.js's `analytics.measurementId` (@rdrive/helper-analytics'
 * createAnalytics loads the tag). Was hard-coded twice: index.html's inline gtag snippet and the
 * Vuex analytics module, both gone. The same property project-overview reports to (per-dashboard
 * separation is IA_ABSORPTION_PLAN Phase 0 step 4, with CI).
 */
export const GA_MEASUREMENT_ID = 'G-QTYQ7961QF';
